import {
  useAdvancesBalance,
  useAdvancesBalanceForm,
} from "../../../hooks/advances_balance/useAdvancesBalance";
import { useAdvancesTransactions } from "../../../hooks/advances_balance/useAdvancesTransaction";
import { useAdvancesLinkedcars } from "../../../hooks/advances_balance/useAdvancesLinkedcars";
import useBookingTypeConfigurable, {
  useBookingTypeConfigurableForm,
} from "../../../hooks/booking_type_configurable/useBookingTypeConfigurable";
import {
  useCouponsSales,
  useCouponsSalesForm,
} from "../../../hooks/coupons/useCouponsSales";
import { useReconciliationErrorlogs } from "../../../hooks/logs/useReconciliationErrorlogs";
import { useStatementLogs } from "../../../hooks/logs/useStatementLogs";
import {
  usePaymentModeForm,
  usePaymentModes,
} from "../../../hooks/parking/useBookingMode";
import {
  useCurrentlyActiveParkedCars,
  useCurrentlyActiveParkedCarsForm,
} from "../../../hooks/parking/useCurrentlyActiveParkedCars";
import { useParkedCars } from "../../../hooks/parking/useParkedCars";
import useParkedCarsService from "../../../hooks/parking/useParkedCarsService";
import { useParkings, useParkingForm } from "../../../hooks/parking/useParking";
import {
  useParkingRateForm,
  useParkingRates,
} from "../../../hooks/parking/useParkingRates";
import {
  usePenaltySettingForm,
  usePenaltySettings,
} from "../../../hooks/parking/usePenaltySettings";
import { useSlotForm, useSlots } from "../../../hooks/parking/useSlot";
import { useStreetForm, useStreets } from "../../../hooks/parking/useStreet";
import {
  useTelecomNetworkCodeForm,
  useTelecomNetworkCodes,
} from "../../../hooks/parking/useTelecomNetworkCodes";
import { usePaymentsForm } from "../../../hooks/payments/usePayments";
import {
  useReconciliation,
  useReconciliationForm,
} from "../../../hooks/reconciliation/useReconciliation";
import {
  useBillingInvoices,
  useBillingInvoicesForm,
} from "../../../hooks/reservation/useBillingInvoices";
import {
  useBookingReservationRates,
  useBookingReservationRateForm,
} from "../../../hooks/reservation/useBookingReservationRate";
import {
  useCarSlotMapping,
  useCarSlotMappingForm,
} from "../../../hooks/reservation/useCarSlotMapping";
import {
  useLiquidationRequestForm,
  useLiquidationRequests,
} from "../../../hooks/reservation/useLiquidationRequests";
import { usePaidRequests } from "../../../hooks/reservation/usePaidRequests";
import {
  usePaymentRequestForm,
  usePaymentRequests,
} from "../../../hooks/reservation/usePaymentRequests";
import {
  useServiceRates,
  useServiceRateForm,
} from "../../../hooks/service_rates/useServiceRates";
import {
  useServiceTypes,
  useServiceTypesForm,
} from "../../../hooks/service_types/useServiceTypes";
import {
  submitServiceRates,
  submitServiceTypes,
  submitStreetsData,
  submitSurchargeConfigurables,
} from "../../../hooks/submission/useSubmission";
import {
  useSurchargeConfigurables,
  useSurchargeConfigurablesForm,
} from "../../../hooks/surcharge_configurables/useSurchargeConfigurables";
import { useSurcharges } from "../../../hooks/surcharge_configurables/useSurcharges";
import {
  useSystemAccountsManagementForm,
  useSystemAccountManagements,
} from "../../../hooks/system_config/useSystemAccountManagement";
import {
  API_ADVANCES_BALANCE_PAGINATED,
  API_ADVANCES_TRANSACTIONS_PAGINATED,
  API_BILLING_INVOICES_PAGINATED,
  API_BOOKING_RESERVATION_RATES_PAGINATED,
  API_BOOKING_TYPE_CONFIGURABLE,
  API_CAR_SIZE_SLOT_MAPPING_PAGINATED,
  API_COLLECT_PAYMENT,
  API_COUPON_SALES,
  API_CURRENTLY_ACTIVE_PARKINGS_PAGINATED,
  API_DAILY_COLLECTIONS,
  API_LINKED_CARS_PAGINATED,
  API_LIQUIDATION_REQUESTS,
  API_NEGOTIATIONS,
  API_PAID_REQUESTS_PAGINATED,
  API_PARKED_CARS_PAGINATED,
  API_PARKED_CARS_SERVICES_PAGINATED,
  API_PARKING_RATES_PAGINATED,
  API_PARKINGS,
  API_PAY_WAGES,
  API_PAYABLE_WAGES,
  API_PAYMENT_MODES_PAGINATED,
  API_PAYMENT_REQUESTS_PAGINATED,
  API_PENALTIES,
  API_PENALTY_SETTINGS_PAGINATED,
  API_RECONCILIATION_ERROR_LOGS_PAGINATED,
  API_RECONCILIATIONS,
  API_REVERSAL_HOLDINGS,
  API_REVERSAL_REQUESTS,
  API_SERVICE_RATES_PAGINATED,
  API_SERVICE_TYPES_PAGINATED,
  API_SLOTS_PAGINATED,
  API_STAFF_WAGES,
  API_STATEMENT_LOGS_PAGINATED,
  API_STICKER_TYPES,
  API_STREETS_PAGINATED,
  API_SURCHARGE_CONFIGURABLES_PAGINATED,
  API_SURCHARGES_PAGINATED,
  API_SYSTEM_ACCOUNTS,
  API_TELECOM_NETWORK_CODES_PAGINATED,
  API_TRANSACTABLE_ACCOUNTS_DETAILS,
  API_USSD_LOGS,
  API_USSD_STICKERS,
  API_WAGE_PAYMENTS_HISTORY,
  API_WAGES,
  API_WEEKLY_COLLECTIONS,
} from "../../../utils/apis";
import {
  ADVANCE_BALANCE,
  ADVANCE_BALANCES,
  ADVANCES_TRANSACTION,
  ADVANCES_TRANSACTIONS,
  BILLING_INVOICE,
  BILLING_INVOICES,
  BOOKING_RESERVATION_RATE,
  BOOKING_RESERVATION_RATES,
  BOOKING_TYPE_CONFIGURABLE,
  BOOKING_TYPE_CONFIGURABLES,
  CAR_SLOT_MAPPING,
  CAR_SLOT_MAPPINGS,
  CURRENTLY_PARKED_CAR,
  LINKED_CARS,
  LINKED_CARS_PAGINATED,
  PAID_REQUEST,
  PAID_REQUESTS,
  PARKED_CAR,
  PARKED_CARS,
  PARKED_CARS_SERVICES,
  PARKED_CARS_SERVICES_PAGINATED,
  PARKING_RATE,
  PARKING_RATES,
  PARKINGS,
  PAYMENT_MODE,
  PAYMENT_MODES,
  PAYMENT_REQUEST,
  PAYMENT_REQUESTS,
  PENALTY_SETTING,
  PENALTY_SETTINGS,
  RECONCILAITION,
  RECONCILAITIONS,
  RECONCILIATION_ERROR_LOG,
  RECONCILIATION_ERROR_LOGS,
  SERVICE_RATE,
  SERVICE_RATES,
  SERVICE_TYPE,
  SERVICE_TYPES,
  SLOT,
  SLOTS,
  STATEMENT_LOG,
  STATEMENT_LOGS,
  STICKER_TYPE,
  STICKER_TYPES,
  STREET,
  STREETS,
  SURCHARGE,
  SURCHARGE_CONFIGURABLE,
  SURCHARGE_CONFIGURABLES,
  SURCHARGES,
  TELECOM_NETWORK_CODE,
  TELECOM_NETWORK_CODES,
} from "../../../utils/constants";
import { URL_CURRENTLY_PARKED_CARS } from "../../../utils/urls";
import {
  useTransactableAccountDetails,
  useTransactableAccountDetailsForm,
} from "../trail_balance/useTransactableAccountDetails";
import {
  useNegotiations,
  useNegotiationsForm,
} from "../../../hooks/negotiations/useNegotiations";
import useWagesForm from "../../../hooks/wages/useWagesForm";
import useWages from "../../../hooks/wages/useWages";
import useStaffWages from "../../../hooks/wages/useStaffWages";
import useStaffWagesForm from "../../../hooks/wages/useStaffWagesForm";
import useDailyCollections from "../../../hooks/wages/useDailyCollections";
import useWeeklyCollections from "../../../hooks/wages/useWeeklyCollections";
import usePayableWages from "../../../hooks/wages/usePayableWages";
import useWagesPaymentHistory from "../../../hooks/wages/useWagesPaymentHistory";
import { usePayWagesForm } from "../../../hooks/wages/usePayWagesForm";
import { usePenalties } from "../../../hooks/penalties/usePenalties";
import { useUSSDLogs } from "../../../hooks/ussd/useUSSDLogs";
import {
  useUSSDStickers,
  useUSSDStickersForm,
} from "../../../hooks/ussd/useUSSDStickers";
import { useReversalRequests } from "../../../hooks/advances_balance/useReversalRequests";
import { useReversalHoldings } from "../../../hooks/advances_balance/useReversalHoldings";

export const streetRegisterRoutes = {
  streets: useStreets,
  parking_yards: useParkings,
  slots: useSlots,
  parking_rates: useParkingRates,
  parked_cars: useParkedCars,
  currently_parked_cars: useCurrentlyActiveParkedCars,
  parked_cars_services: useParkedCarsService,
  payment_modes: usePaymentModes,
  telecom_codes: useTelecomNetworkCodes,
  penalty_settings: usePenaltySettings,
  booking_rates: useBookingReservationRates,
  payment_requests: usePaymentRequests,
  payments: usePaidRequests,
  billing_invoices: useBillingInvoices,
  car_slot_mappings: useCarSlotMapping,
  advance_balances: useAdvancesBalance,
  linked_cars: useAdvancesLinkedcars,
  advances_transactions: useAdvancesTransactions,
  system_accounts: useSystemAccountManagements,
  // sticker_types: useStickerTypes,
  booking_type_configurable: useBookingTypeConfigurable,
  liquidation_requests: useLiquidationRequests,
  coupon_sales: useCouponsSales,
  transactable_accounts_details: useTransactableAccountDetails,
  reconciliations: useReconciliation,
  service_rates: useServiceRates,
  service_types: useServiceTypes,
  surcharge_configurables: useSurchargeConfigurables,
  surcharges: useSurcharges,
  penalties: usePenalties,
  statement_logs: useStatementLogs,
  reconciliation_error_logs: useReconciliationErrorlogs,
  negotiated_payments: useNegotiations,
  wages: useWages,
  staff_wages: useStaffWages,
  daily_wages_collections: useDailyCollections,
  weekly_wages_collections: useWeeklyCollections,
  payable_wages: usePayableWages,
  wage_payment_history: useWagesPaymentHistory,
  ussd_logs: useUSSDLogs,
  ussd_stickers: useUSSDStickers,
  reversal_requests: useReversalRequests,
  reverse_transaction: useReversalHoldings,
};

export const streetFormRoutes = {
  streets: useStreetForm,
  parking_rates: useParkingRateForm,
  parking_yards: useParkingForm,
  slots: useSlotForm,
  parked_cars: useParkingForm,
  currently_parked_cars: useCurrentlyActiveParkedCarsForm,
  payment_modes: usePaymentModeForm,
  telecom_codes: useTelecomNetworkCodeForm,
  booking_rates: useBookingReservationRateForm,
  payments: usePaymentRequestForm,
  billing_invoices: useBillingInvoicesForm,
  car_slot_mappings: useCarSlotMappingForm,
  advance_balances: useAdvancesBalanceForm,
  // advances_transactions: useAdvancesBalanceForm,
  penalty_settings: usePenaltySettingForm,
  system_accounts: useSystemAccountsManagementForm,
  // sticker_types: useStickerTypesForm,
  booking_type_configurable: useBookingTypeConfigurableForm,
  liquidation_requests: useLiquidationRequestForm,
  coupon_sales: useCouponsSalesForm,
  make_payments: usePaymentsForm,
  transactable_accounts_details: useTransactableAccountDetailsForm,
  reconciliations: useReconciliationForm,
  service_rates: useServiceRateForm,
  service_types: useServiceTypesForm,
  surcharge_configurables: useSurchargeConfigurablesForm,
  negotiated_payments: useNegotiationsForm,
  wages: useWagesForm,
  staff_wages: useStaffWagesForm,
  pay_wages: usePayWagesForm,
  ussd_stickers: useUSSDStickersForm,
};

export const streetFormSubmit = {
  streets: submitStreetsData,
  parking_yards: submitStreetsData,
  slots: submitStreetsData,
  parking_rates: submitStreetsData,
  parked_cars: submitStreetsData,
  currently_parked_cars: submitStreetsData,
  advance_balances: submitStreetsData,
  payment_modes: submitStreetsData,
  telecom_codes: submitStreetsData,
  booking_rates: submitStreetsData,
  payment_requests: submitStreetsData,
  payments: submitStreetsData,
  billing_invoices: submitStreetsData,
  car_slot_mappings: submitStreetsData,
  penalty_settings: submitStreetsData,
  system_accounts: submitStreetsData,
  liquidation_requests: submitStreetsData,
  reconciliations: submitStreetsData,
  service_rates: submitServiceRates,
  service_types: submitServiceTypes,
  surcharge_configurables: submitSurchargeConfigurables,
};

export const streetApis = {
  streets: API_STREETS_PAGINATED,
  parking_yards: API_PARKINGS,
  slots: API_SLOTS_PAGINATED,
  parking_rates: API_PARKING_RATES_PAGINATED,
  parked_cars: API_PARKED_CARS_PAGINATED,
  payment_modes: API_PAYMENT_MODES_PAGINATED,
  telecom_codes: API_TELECOM_NETWORK_CODES_PAGINATED,
  booking_rates: API_BOOKING_RESERVATION_RATES_PAGINATED,
  payment_requests: API_PAYMENT_REQUESTS_PAGINATED,
  payments: API_PAID_REQUESTS_PAGINATED,
  billing_invoices: API_BILLING_INVOICES_PAGINATED,
  car_slot_mappings: API_CAR_SIZE_SLOT_MAPPING_PAGINATED,
  currently_parked_cars: API_CURRENTLY_ACTIVE_PARKINGS_PAGINATED,
  parked_cars_services: API_PARKED_CARS_SERVICES_PAGINATED,
  advance_balances: API_ADVANCES_BALANCE_PAGINATED,
  linked_cars: API_LINKED_CARS_PAGINATED,
  advances_transactions: API_ADVANCES_TRANSACTIONS_PAGINATED,
  penalty_settings: API_PENALTY_SETTINGS_PAGINATED,
  system_accounts: API_SYSTEM_ACCOUNTS,
  liquidation_requests: API_LIQUIDATION_REQUESTS,
  coupon_sales: API_COUPON_SALES,
  make_payments: API_COLLECT_PAYMENT,
  transactable_accounts_details: API_TRANSACTABLE_ACCOUNTS_DETAILS,
  reconciliations: API_RECONCILIATIONS,
  sticker_types: API_STICKER_TYPES,
  booking_type_configurable: API_BOOKING_TYPE_CONFIGURABLE,
  service_rates: API_SERVICE_RATES_PAGINATED,
  service_types: API_SERVICE_TYPES_PAGINATED,
  surcharge_configurables: API_SURCHARGE_CONFIGURABLES_PAGINATED,
  surcharges: API_SURCHARGES_PAGINATED,
  penalties: API_PENALTIES,
  reconciliation_error_logs: API_RECONCILIATION_ERROR_LOGS_PAGINATED,
  statement_logs: API_STATEMENT_LOGS_PAGINATED,
  negotiated_payments: API_NEGOTIATIONS,
  wages: API_WAGES,
  staff_wages: API_STAFF_WAGES,
  daily_wages_collections: API_DAILY_COLLECTIONS,
  weekly_wages_collections: API_WEEKLY_COLLECTIONS,
  payable_wages: API_PAYABLE_WAGES,
  wage_payment_history: API_WAGE_PAYMENTS_HISTORY,
  pay_wages: API_PAY_WAGES,
  ussd_logs: API_USSD_LOGS,
  ussd_stickers: API_USSD_STICKERS,
  reversal_requests: API_REVERSAL_REQUESTS,
  reverse_transaction: API_REVERSAL_HOLDINGS,
};

export function getStreetDataApi(type: any) {
  const typeMapping = {
    [STREET]: API_STREETS_PAGINATED,
    [STREETS]: API_STREETS_PAGINATED,

    parking_yard: API_PARKINGS,
    [PARKINGS]: API_PARKINGS,

    [SLOT]: API_SLOTS_PAGINATED,
    [SLOTS]: API_SLOTS_PAGINATED,

    [PARKING_RATE]: API_PARKING_RATES_PAGINATED,
    [PARKING_RATES]: API_PARKING_RATES_PAGINATED,

    [PARKED_CAR]: API_PARKED_CARS_PAGINATED,
    [PARKED_CARS]: API_PARKED_CARS_PAGINATED,

    [CURRENTLY_PARKED_CAR]: API_CURRENTLY_ACTIVE_PARKINGS_PAGINATED,
    [URL_CURRENTLY_PARKED_CARS]: API_CURRENTLY_ACTIVE_PARKINGS_PAGINATED,

    [PARKED_CARS_SERVICES]: API_PARKED_CARS_SERVICES_PAGINATED,
    [PARKED_CARS_SERVICES_PAGINATED]: API_PARKED_CARS_SERVICES_PAGINATED,

    [PAYMENT_MODE]: API_PAYMENT_MODES_PAGINATED,
    [PAYMENT_MODES]: API_PAYMENT_MODES_PAGINATED,

    [TELECOM_NETWORK_CODE]: API_TELECOM_NETWORK_CODES_PAGINATED,
    [TELECOM_NETWORK_CODES]: API_TELECOM_NETWORK_CODES_PAGINATED,

    [BOOKING_RESERVATION_RATE]: API_BOOKING_RESERVATION_RATES_PAGINATED,
    [BOOKING_RESERVATION_RATES]: API_BOOKING_RESERVATION_RATES_PAGINATED,

    [PAYMENT_REQUESTS]: API_PAYMENT_REQUESTS_PAGINATED,
    [PAYMENT_REQUEST]: API_PAYMENT_REQUESTS_PAGINATED,

    [PAID_REQUESTS]: API_PAYMENT_REQUESTS_PAGINATED,
    [PAID_REQUEST]: API_PAYMENT_REQUESTS_PAGINATED,

    [BILLING_INVOICES]: API_BILLING_INVOICES_PAGINATED,
    [BILLING_INVOICE]: API_BILLING_INVOICES_PAGINATED,

    [CAR_SLOT_MAPPINGS]: API_CAR_SIZE_SLOT_MAPPING_PAGINATED,
    [CAR_SLOT_MAPPING]: API_CAR_SIZE_SLOT_MAPPING_PAGINATED,

    [ADVANCE_BALANCES]: API_ADVANCES_BALANCE_PAGINATED,
    [ADVANCE_BALANCE]: API_ADVANCES_BALANCE_PAGINATED,

    [ADVANCES_TRANSACTIONS]: API_ADVANCES_TRANSACTIONS_PAGINATED,
    [ADVANCES_TRANSACTION]: API_ADVANCES_TRANSACTIONS_PAGINATED,

    [LINKED_CARS]: API_LINKED_CARS_PAGINATED,
    [LINKED_CARS_PAGINATED]: API_LINKED_CARS_PAGINATED,

    [PENALTY_SETTING]: API_PENALTY_SETTINGS_PAGINATED,
    [PENALTY_SETTINGS]: API_PENALTY_SETTINGS_PAGINATED,

    [RECONCILAITION]: API_RECONCILIATIONS,
    [RECONCILAITIONS]: API_RECONCILIATIONS,

    [STICKER_TYPES]: API_STICKER_TYPES,
    [STICKER_TYPE]: API_STICKER_TYPES,

    [BOOKING_TYPE_CONFIGURABLE]: API_BOOKING_TYPE_CONFIGURABLE,
    [BOOKING_TYPE_CONFIGURABLES]: API_BOOKING_TYPE_CONFIGURABLE,

    [SERVICE_RATES]: API_SERVICE_RATES_PAGINATED,
    [SERVICE_RATE]: API_SERVICE_RATES_PAGINATED,

    [SERVICE_TYPES]: API_SERVICE_TYPES_PAGINATED,
    [SERVICE_TYPE]: API_SERVICE_TYPES_PAGINATED,

    [SURCHARGE_CONFIGURABLES]: API_SURCHARGE_CONFIGURABLES_PAGINATED,
    [SURCHARGE_CONFIGURABLE]: API_SURCHARGE_CONFIGURABLES_PAGINATED,

    [SURCHARGE]: API_SURCHARGES_PAGINATED,
    [SURCHARGES]: API_SURCHARGES_PAGINATED,

    [RECONCILIATION_ERROR_LOGS]: API_RECONCILIATION_ERROR_LOGS_PAGINATED,
    [RECONCILIATION_ERROR_LOG]: API_RECONCILIATION_ERROR_LOGS_PAGINATED,

    [STATEMENT_LOGS]: API_STATEMENT_LOGS_PAGINATED,
    [STATEMENT_LOG]: API_STATEMENT_LOGS_PAGINATED,
  };

  return typeMapping[type];
}
